module.exports = {
    bindings: {
        isLarge: '<',
        item: '<'
    },
    controller: customsRulingsButtonController,
    templateUrl: 'cross/components/customs-rulings-button.html'
};

customsRulingsButtonController.$inject = [
    'common', 
    'customsRulingsModal'
];

function customsRulingsButtonController(
    common, 
    customsRulingsModal
) {
    
    var vm = {
        openCustomsRulingsModal: openCustomsRulingsModal
    };

    function openCustomsRulingsModal() {
        var numberPattern = /^\s*(?:\d{2}[\s.]*){1,5}$/;

        var code = common.formatting.removeTrailingZeros(vm.item.code);

        if (numberPattern.test(vm.item.searchQuery)) {
            customsRulingsModal.show(code, '');
        }
        else {
            customsRulingsModal.show(code, vm.item.searchQuery);
        }
    }


    return vm;

}

